module.exports = __webpack_public_path__ + "static/scale-model-of-san-francisco-city-guide-in-berkeley-california-ac3afe7ebf5086d5a84cb504f7e131dd.png";